import uuid from "react-uuid";
import { deepCopy } from "../../constants";

let initialState = {
  tabLoader: false,
  dashboardLoader: false,
  dashboardData: null,
  dashboardTemplateData: null,
  sectionFetchLoader: false,
  selectedSectionIndex: 0,
  // Multi-level dashboard stack support
  openedDashboardList: [], // Array of dashboardData objects
  activeDashboardIndex: 0, // 0 means no dashboard open, at first dashboard
  // If using stack, openedDashboardList[0] is the root dashboard
};
const DeepDiveDashboard = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_DEEP_DIVE_DASHBOARD": {
      try {
        if (action?.isBackedClick) {
          let popIndex = state?.activeDashboardIndex - 1;
          // Pop last dashboard (like back navigation)
          if (popIndex <= 0) {
            // Already at root, do nothing or reset to root
            // Full reset
            return {
              ...initialState,
            };
          }
          const newIndex = popIndex - 1; // becouse we are popping the last dashboard and current activeDashboardIndex is greater than newIndex
          const newOpenedDashboardList = state?.openedDashboardList?.slice(
            0,
            newIndex + 1
          );
          return {
            ...state,
            dashboardData: newOpenedDashboardList?.[newIndex]?.dashboardData
              ? deepCopy(newOpenedDashboardList[newIndex]?.dashboardData)
              : null,
            dashboardTemplateData: newOpenedDashboardList?.[newIndex]
              ?.dashboardTemplateData
              ? deepCopy(
                  newOpenedDashboardList[newIndex]?.dashboardTemplateData
                )
              : null,
            selectedSectionIndex: newOpenedDashboardList?.[newIndex]
              ?.selectedSectionIndex
              ? newOpenedDashboardList?.[newIndex]?.selectedSectionIndex
              : 0,
            openedDashboardList: newOpenedDashboardList,
            activeDashboardIndex: popIndex,
          };
        } else {
          // Full reset
          return {
            ...initialState,
          };
        }
      } catch (e) {
        console.error("Error in RESET_DEEP_DIVE_DASHBOARD action:", e);
      }

      // Full reset
      return {
        ...initialState,
      };
    }
    case "SET_DEEP_DIVE_DASHBOARD_DATA": {
      try {
        // If using stack, update the dashboard at the current index
        let newOpenedDashboardList = [...(state?.openedDashboardList || [])];
        let idx = state?.activeDashboardIndex; // Use the exact current index
        if (idx > 0 && idx >= newOpenedDashboardList?.length) {
          let prevIndex = idx - 1;
          if (prevIndex >= 0) {
            newOpenedDashboardList[prevIndex] = {
              dashboardData: {
                ...((state?.dashboardData
                  ? deepCopy(state?.dashboardData)
                  : state?.dashboardData) || {}),
              },
              dashboardTemplateData: state?.dashboardTemplateData
                ? deepCopy(state?.dashboardTemplateData)
                : null,
              selectedSectionIndex: state?.selectedSectionIndex
                ? state?.selectedSectionIndex
                : 0,
            };
          }
          newOpenedDashboardList[idx] = {
            ...(newOpenedDashboardList[idx] || {}),
            ...{
              dashboardData: {
                ...(newOpenedDashboardList[idx]?.dashboardData || {}),
                ...action?.dashboardData,
              },
              dashboardTemplateData: null,
              selectedSectionIndex: 0,
            },
          };
        } else if (idx === 0) {
          // No dashboard open, treat as single dashboard
          newOpenedDashboardList = [
            { dashboardData: null, dashboardTemplateData: null },
          ];
          idx = 0;
        }
        return {
          ...state,
          dashboardData: {
            ...(state?.dashboardData || {}),
            ...action?.dashboardData,
          },
          dashboardTemplateData: null,
          selectedSectionIndex: 0,
          openedDashboardList: newOpenedDashboardList,
          activeDashboardIndex: idx + 1, // Increment index to reflect new dashboard
        };
      } catch (e) {
        console.error("Error in SET_DEEP_DIVE_DASHBOARD_DATA action:", e);
        return { ...state };
      }

      return {
        ...state,
      };
    }

    case "SET_DEEP_DIVE_TAB_LOADER":
      return {
        ...state,
        tabLoader: action.value,
      };
    case "SET_DEEP_DIVE_DASHBOARD_LOADER":
      return {
        ...state,
        dashboardLoader: action.value,
      };
    case "SET_DEEP_DIVE_DASHBOARD_TEMPLATE_DATA":
      return {
        ...state,
        dashboardTemplateData: action?.dashboardTemplateData
          ? {
              ...action?.dashboardTemplateData,
            }
          : null,
      };
    case "SET_DEEP_DIVE_SECTION_FETCH_LOADER":
      return {
        ...state,
        sectionFetchLoader: action?.value,
      };
    case "SET_SECTIONS_IN_DASHBOARD_TEMPLATE_DATA":
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: action?.sections,
              onlyWidgets: action?.isOnlyWidgets ? true : false,
              widgets: null,
            }
          : null,
      };
    case "SET_DEEP_DIVE_SELECTED_SECTION_INDEX":
      return {
        ...state,
        selectedSectionIndex: action.value,
      };
    case "SET_IS_DEEPDIVE_IN_DASHBOARD_TEMPLATE_DATA":
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              isDeepDive: action?.isDeepDive || false,
            }
          : null,
      };
    case "SET_WIDGETS_IN_SECTION":
      if (
        action?.sectionId &&
        action?.updatedSectionData &&
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections.map(
          (section, section_index) => {
            if (section?.section_id === action?.sectionId) {
              return {
                ...section,
                ...action?.updatedSectionData,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };
    case "CLEAR_WIDGET_GRAPH_DATA_IN_DEEPDIVE_TEMPLATE_DATA":
      // sectionIndex: sectionIndex,
      // widgetIndex: widgetIndex,
      // widget_id: widget_id,
      if (
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      if (widget_index === action?.widgetIndex) {
                        // delete graphData and data
                        if (widget?.graphData) delete widget.graphData;
                        if (widget?.persist_graphdata)
                          delete widget.persist_graphdata;
                        // if (widget?.deep_dive_on) delete widget.deep_dive_on;
                        if (widget?.data) delete widget.data;
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };

    case "SET_WIDGET_GRAPH_DATA_IN_DEEPDIVE_TEMPLATE_DATA":
      // graphData: value,
      // sectionIndex,
      // widgetIndex,
      // body,
      // graphObject,
      if (
        action?.graphData &&
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      if (widget_index === action?.widgetIndex) {
                        // To reset offset value in case of global changes
                        if (
                          !action?.graphObject?.offset_flag &&
                          widget?.order_by
                        ) {
                          widget.order_by.offset = 0;
                        }
                        if (
                          action?.graphObject?.temp_exclude_words &&
                          widget &&
                          !widget?.temp_exclude_words
                        ) {
                          widget.temp_exclude_words =
                            action?.graphObject?.temp_exclude_words;
                        }
                        widget.graphData = action?.graphData;
                        widget.payload = action?.body;
                        widget.insights = null;
                        widget.open = false;
                        widget.profile_filters = action?.body?.profile_filters;
                        widget.quickFilterDropdownListInNoData =
                          action?.quickFilterDropdownListInNoData &&
                          Array.isArray(action?.quickFilterDropdownListInNoData)
                            ? action?.quickFilterDropdownListInNoData
                            : null;
                        if (typeof action?.graphData !== "string") {
                          widget.graphData.id = uuid();
                        }
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };
    case "SET_DASHBOARD_CALLED_API_LIST_IN_DEEPDIVE_TEMPLATE_DATA":
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              dashboard_called_api_list: action?.dashboard_called_api_list
                ? action?.dashboard_called_api_list
                : [],
            }
          : null,
      };
    case "SET_WIDGET_AI_GENERATED_INSIGHTS_STATUS_IN_DEEPDIVE_TEMPLATE_DATA":
      // sectionIndex: sectionIndex,
      // widgetIndex: widgetIndex,
      // open,
      // clear,
      if (
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      if (widget_index === action?.widgetIndex) {
                        widget.open = action?.open;
                        if (action?.clear && widget?.insights) {
                          widget.insights = null;
                        }
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };

    case "SET_WIDGET_WORDCLOUD_COLOUR_IN_DEEPDIVE_TEMPLATE_DATA":
      // sectionIndex: sectionIndex,
      // widgetIndex: widgetIndex,
      // wordcloudColor,
      // clearData,
      if (
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      if (widget_index === action?.widgetIndex) {
                        let updatedChartSettings = {
                          ...widget?.chart?.chart_settings,
                          wordcloud_color: action?.wordcloudColor,
                        };
                        widget.chart.chart_settings = updatedChartSettings;
                        if (action?.clearData) {
                          // delete graphData and data
                          if (widget?.graphData) delete widget.graphData;
                          if (widget?.persist_graphdata)
                            delete widget.persist_graphdata;
                          // if (widget?.deep_dive_on) delete widget.deep_dive_on;
                          if (widget?.data) delete widget.data;
                        }
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };

    case "SET_DEFAULT_SORT_BY_VALUE_IN_WIDGET_METADATA_IN_DEEPDIVE_TEMPLATE_DATA":
      // sectionIndex,
      // widgetIndex,
      // defaultValue,
      if (
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      if (widget_index === action?.widgetIndex) {
                        widget.defaultSortByValue = action?.defaultValue;
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };

    case "SET_SORT_BY_CHANGES_IN_WIDGET_METADATA_IN_DEEPDIVE_TEMPLATE_DATA":
      // sectionIndex: sectionIndex,
      // widgetIndex: widgetIndex,
      // clearData,
      // action_case,
      // updatedKeysObject,
      if (
        Array.isArray(state?.dashboardTemplateData?.sections) &&
        state?.dashboardTemplateData?.sections?.length
      ) {
        const updatedSections = state?.dashboardTemplateData?.sections?.map(
          (section, section_index) => {
            if (section_index === action?.sectionIndex) {
              const updatedWidgetList =
                Array.isArray(section?.widgets) && section?.widgets?.length
                  ? section?.widgets?.map((widget, widget_index) => {
                      let widgetChartType = widget?.chart?.chart_type;
                      if (widget_index === action?.widgetIndex) {
                        if (
                          [
                            "SORT_BY_CHANGE",
                            "PAGINATION_CHANGE",
                            "CARD_FILTER_PILL_CHANGE",
                          ]?.includes(action?.action_case) &&
                          action?.updatedKeysObject
                        ) {
                          widget.order_by = [
                            "post-card",
                            "review-card",
                            "author-card",
                            "prolific-user",
                            "survey-card",
                            "news-card",
                            "custom-card",
                          ].includes(widgetChartType)
                            ? action?.updatedKeysObject?.order_by || null
                            : null;
                          widget.filter_by_data =
                            action?.updatedKeysObject?.filter_by_data || null;
                          widget.filter_by =
                            action?.updatedKeysObject?.filter_by || null;
                        }

                        if (action?.clearData) {
                          // delete graphData and data
                          if (widget?.graphData) delete widget.graphData;
                          if (widget?.persist_graphdata)
                            delete widget.persist_graphdata;
                          // if (widget?.deep_dive_on) delete widget.deep_dive_on;
                          if (widget?.data) delete widget.data;
                        }
                      }
                      return {
                        ...widget,
                      };
                    })
                  : [];
              return {
                ...section,
                widgets: updatedWidgetList,
              };
            }
            return section;
          }
        );
        return {
          ...state,
          dashboardTemplateData: state?.dashboardTemplateData
            ? {
                ...state?.dashboardTemplateData,
                sections: updatedSections,
              }
            : null,
        };
      }
      return {
        ...state,
        dashboardTemplateData: state?.dashboardTemplateData
          ? {
              ...state?.dashboardTemplateData,
              sections: [...state?.dashboardTemplateData?.sections],
            }
          : null,
      };

    default:
      return state;
  }
};

export default DeepDiveDashboard;
